/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} MinimumInputs */

const en_minimum = /** @type {(inputs: MinimumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min`)
};

const es_minimum = /** @type {(inputs: MinimumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min`)
};

/**
* | output |
* | --- |
* | "Min" |
*
* @param {MinimumInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const minimum = /** @type {((inputs?: MinimumInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<MinimumInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minimum(inputs)
	return es_minimum(inputs)
});